import mock from '../../mockAdapter';

interface NotesType {
    id?: number | any;
    color?: string;
    title?: string;
    datef?: string | Date;
}

const NotesData: NotesType[] = [
    {
        id: 1,
        color: 'primary',
        title: 'Pedido de 10 cajas de manzanas para el cliente Juan Pérez en la calle 5 de Mayo.',
        datef: '2025-03-03T23:28:56.782Z'
    },
    {
        id: 2,
        color: 'error',
        title: 'Solicitud de 5 sacos de arroz para la tienda de María López en la avenida Revolución.',
        datef: '2025-03-02T23:28:56.782Z'
    },
    {
        id: 3,
        color: 'warning',
        title: 'Orden de 20 litros de leche para el supermercado de Carlos García en la calle Independencia.',
        datef: '2025-03-01T23:28:56.782Z'
    },
    {
        id: 4,
        color: 'success',
        title: 'Compra de 15 kilos de azúcar para la panadería de Ana Martínez en la calle Juárez.',
        datef: '2025-03-03T23:28:56.782Z'
    }
];

interface colorVariationType {
    id?: number;
    color?: string;
}

export const colorVariation: colorVariationType[] = [
    {
        id: 1,
        color: 'warning'
    },
    {
        id: 2,
        color: 'secondary'
    },
    {
        id: 3,
        color: 'error'
    },
    {
        id: 4,
        color: 'success'
    },
    {
        id: 5,
        color: 'primary'
    }
];

mock.onGet('/api/data/notes/NotesData').reply(() => {
    return [200, NotesData];
});
export default NotesData;
